import { Component } from 'angular2/core';
import { Router } from 'angular2/router';

@Component({
  selector: 'logout',
  template: '',
})
export class Logout {
  constructor(public router: Router) {
    localStorage.removeItem('jwt');
    this.router.navigateByUrl('/admin/users/login');
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/user/logout/logout.ts
 **/